export const KEY_SESSION_STORAGE_PAYMENT_BASKET_ID = "payment_basket_id";
export const RECOVERY_SESSION_KEY = "recovery_session";
